export const scandinavianCodes = ['NO', 'DK', 'SE', 'FI', 'IS']

export const scandinavianNationalities = [
  'Danish',
  'Finnish',
  'Icelandic',
  'Norwegian',
  'Swedish',
]
